export default async function getImageMegapixels(url: string) {
  return new Promise<number>((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      resolve((image.height * image.width) / 1000000);
    };
    image.onerror = (e) => {
      reject(e);
    };
    image.src = url;
  });
}
